import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import { Snackbar, withStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
var NotificationContext = /*#__PURE__*/React.createContext();
var styles = {
  feedbackMessage: {
    '&': {
      'z-index': 10000,
      'margin-top': '50px'
    },
    '& .MuiAlert-message': {
      fontSize: '14px'
    }
  }
};

var NotificationProviderComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationProviderComponent, _React$Component);

  var _super = _createSuper(NotificationProviderComponent);

  function NotificationProviderComponent(props) {
    var _this;

    _classCallCheck(this, NotificationProviderComponent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "showNotification", function (feedback) {
      if (!feedback || !feedback.severity || !feedback.message) {
        return;
      }

      _this.setState({
        isSnackbarOpen: true,
        feedback: feedback
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeNotification", function () {
      _this.setState({
        isSnackbarOpen: false,
        feedback: {}
      });
    });

    _this.state = {
      isSnackbarOpen: false,
      feedback: {}
    };
    return _this;
  }

  _createClass(NotificationProviderComponent, [{
    key: "render",
    value: function render() {
      var feedback = this.state.feedback;
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
        value: {
          showNotification: this.showNotification
        }
      }, this.props.children, /*#__PURE__*/React.createElement(Snackbar, {
        open: this.state.isSnackbarOpen,
        className: classes.feedbackMessage,
        autoHideDuration: 5000,
        onClose: this.closeNotification,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      }, /*#__PURE__*/React.createElement(Alert, {
        severity: feedback.severity,
        className: "feedbackMessage",
        onClose: this.closeNotification
      }, feedback.message)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NotificationProviderComponent;
}(React.Component);

var withNotification = function withNotification(Component) {
  return function WrapperComponent(props) {
    return /*#__PURE__*/React.createElement(NotificationContext.Consumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, context));
    });
  };
};

var NotificationProvider = withStyles(styles)(NotificationProviderComponent);
export { NotificationContext, NotificationProvider, withNotification };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NotificationContext, "NotificationContext", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/NotificationContext.js");
  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/NotificationContext.js");
  reactHotLoader.register(NotificationProviderComponent, "NotificationProviderComponent", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/NotificationContext.js");
  reactHotLoader.register(withNotification, "withNotification", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/NotificationContext.js");
  reactHotLoader.register(NotificationProvider, "NotificationProvider", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/NotificationContext.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();